export default function PaginationTextView(page,count,total) {
  let result=page==1? 1:count*page-count+1;
  let data=page==1?count:count*page;
  return total == 0 ? "" :`Showing ${result} to ${data>total?total:data}  of ${total} records`
}
